import { Component, Input, Output, EventEmitter } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { LucideAngularModule, Search } from 'lucide-angular';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [FormsModule, LucideAngularModule],
  template: `
    <div class="relative">
      <input
        [ngModel]="value"
        (ngModelChange)="valueChange.emit($event)"
        [placeholder]="placeholder"
        [disabled]="disabled"
        class="search-input pl-12"
      />
      <lucide-angular
        [img]="SearchIcon"
        class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary"
      ></lucide-angular>
    </div>
  `,
})
export class SearchInputComponent {
  @Input() value: string = '';
  @Input() placeholder: string = 'Buscar...';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  readonly SearchIcon = Search;
}
